import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';
import { UserFeeDeductionStatus } from '../../types/userFeeDeduction';

export const userFeeDeductionStatusToInfo: {
  [prop in UserFeeDeductionStatus]: {
    color: 'error' | 'info' | 'success' | 'warning';
    icon: React.ElementType;
    menuAction: string;
  };
} = {
  [UserFeeDeductionStatus.PENDING]: {
    color: 'info',
    menuAction: 'Change to Pending',
    icon: InfoIcon,
  },
  [UserFeeDeductionStatus.IN_PROGRESS]: {
    color: 'info',
    menuAction: 'Change to In Progress',
    icon: InfoIcon,
  },
  [UserFeeDeductionStatus.APPROVED]: {
    color: 'success',
    menuAction: 'Approve',
    icon: CheckCircleIcon,
  },
  [UserFeeDeductionStatus.WAITING_CAST_APPROVAL]: {
    color: 'info',
    menuAction: 'Change to waiting cast approval',
    icon: CheckCircleIcon,
  },
  [UserFeeDeductionStatus.APPROVED_BY_CAST]: {
    color: 'success',
    menuAction: 'Change to approved by cast',
    icon: CheckCircleIcon,
  },
  [UserFeeDeductionStatus.CREATED]: {
    color: 'success',
    menuAction: 'Change to created',
    icon: CheckCircleIcon,
  },
  [UserFeeDeductionStatus.FAILED]: {
    color: 'error',
    menuAction: 'Change to failed',
    icon: CheckCircleIcon,
  },
  [UserFeeDeductionStatus.PARTIAL_APPROVED_BY_CAST]: {
    color: 'warning',
    menuAction: 'Partial approve by cast',
    icon: CheckCircleIcon,
  },
  [UserFeeDeductionStatus.PARTIAL_APPROVED]: {
    color: 'warning',
    menuAction: 'Partial approve',
    icon: CheckCircleIcon,
  },
  [UserFeeDeductionStatus.REJECTED]: {
    color: 'error',
    menuAction: 'Reject',
    icon: WarningIcon,
  },
  [UserFeeDeductionStatus.CANCELED]: {
    color: 'error',
    menuAction: 'Cancel',
    icon: CancelScheduleSendIcon,
  },
};
